import { useCallback } from 'react';
import { WIDGET_MESSAGE_ACTIONS } from '../constants/widgetMessageActions';
import { useHelpMessageHandler } from './useHelpMessageHandler';
import { blurElements } from '../utils/helpModal';
export const useHelpModal = () => {
  const messageCallback = useCallback((action, payload) => {
    if (action === WIDGET_MESSAGE_ACTIONS.HELP_MODAL && payload.action) {
      switch (payload.action) {
        case 'modal-open-start':
          blurElements('blur(5px)');
          break;
        case 'modal-close-complete':
          blurElements('none');
          break;
        default:
          console.warn(`Unhandled Help Modal action: ${payload.action}`);
      }
    }
  }, []);
  useHelpMessageHandler(messageCallback);
};
export default useHelpModal;